/**
 * AutoImporting components
 * @param path
 * @returns {function(): *}
 */
const page = path => () =>
    import(/* webpackChunkName: '' */ `./components/${path}`).then(
        m => m.default || m
    );

export const routes = [
    {
        path: "/trabajadores",
        name: "Trabajadores",
        component: page("EmployeesList")
    },
    {
        path: "/trabajadores/:id",
        name: "Trabajador",
        component: page("EmployeeView"),
        hidden: true
    }
];
